// extracted by mini-css-extract-plugin
module.exports = {"bigTitle":"balance_bigTitle__U97XV","successTitle":"balance_successTitle__GiocE","errorTitle":"balance_errorTitle__1zW0B"};